import React, { useState } from "react";

import { Button, Dialog, TextField, DialogActions } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  notesDialogContainer: {
    padding: 20,
    width: 400,
  },
  resolutionTextField: {
    width: "100%",
  },
}));

const FindingsResolutionDialog = (props) => {
  const classes = useStyles();

  const [resolutionNotes, setResolutionNotes] = useState("");

  const handleResolutionNotesChange = (event) => {
    setResolutionNotes(event.target.value);
  };

  const handleClose = () => {
    const { onClose } = props;
    setResolutionNotes("");
    onClose();
  };

  const handleResolveFindings = () => {
    setResolutionNotes("");
    props.handleResolveFindings(resolutionNotes);
  };

  return (
    <Dialog onClose={handleClose} open={props.open}>
      <div className={classes.notesDialogContainer}>
        <TextField
          value={resolutionNotes}
          label={"Resolution Notes"}
          onChange={handleResolutionNotesChange}
          className={classes.resolutionTextField}
          InputProps={{ disableUnderline: true }}
        />
      </div>
      <DialogActions>
        <Button
          onClick={handleClose}
          color={"primary"}
          variant={"outlined"}
          style={{ marginLeft: 5 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleResolveFindings}
          color={"primary"}
          variant={"outlined"}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FindingsResolutionDialog;
